import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent } from "vue"
import _imports_0 from '@/assets/002.jpg'
import _imports_1 from '@/assets/logo_blanco.png'


const _hoisted_1 = { class: "fixed inset-0 z-40 flex" }
const _hoisted_2 = { class: "flex px-4 pb-2 pt-5" }
const _hoisted_3 = { class: "border-b border-gray-200" }
const _hoisted_4 = { class: "grid grid-cols-2 gap-x-4 gap-y-10" }
const _hoisted_5 = { class: "grid" }
const _hoisted_6 = { class: "flex space-x-4" }
const _hoisted_7 = { class: "space-y-6 border-t border-gray-200 px-4 py-6" }
const _hoisted_8 = ["href"]
const _hoisted_9 = { class: "relative bg-gray-900" }
const _hoisted_10 = {
  key: 0,
  "aria-hidden": "true",
  class: "absolute inset-0 overflow-hidden"
}
const _hoisted_11 = {
  key: 1,
  "aria-hidden": "true",
  class: "absolute inset-0 bg-gray-900 opacity-50"
}
const _hoisted_12 = { class: "relative z-10" }
const _hoisted_13 = { "aria-label": "Top" }
const _hoisted_14 = { class: "bg-white/10 backdrop-blur-md backdrop-filter" }
const _hoisted_15 = { class: "mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" }
const _hoisted_16 = { class: "flex h-16 items-center justify-between" }
const _hoisted_17 = { class: "hidden lg:flex lg:flex-1 lg:items-center" }
const _hoisted_18 = { href: "#" }
const _hoisted_19 = { class: "flex flex-1 items-center lg:hidden" }
const _hoisted_20 = {
  href: "#",
  class: "ml-2 p-2 text-white"
}
const _hoisted_21 = { class: "flex flex-1 items-center justify-end" }
const _hoisted_22 = { class: "flex items-center lg:ml-8" }
const _hoisted_23 = {
  href: "#",
  class: "p-2 text-white lg:hidden"
}
const _hoisted_24 = { class: "ml-4 flow-root lg:ml-8" }
const _hoisted_25 = {
  href: "#",
  class: "group -m-2 flex items-center p-2"
}
const _hoisted_26 = {
  key: 2,
  class: "relative mx-auto flex max-w-3xl flex-col items-center px-6 py-32 text-center sm:py-64 lg:px-0"
}

import SuperMenu from './SuperMenu.vue';
  import { getCategories, Category, Brand, Shape } from '@/services/api/navigationService';
  import { ref, onMounted } from 'vue';
  import {
    Dialog,
    DialogPanel,
    Popover,
    PopoverButton,
    PopoverGroup,
    PopoverPanel,
    Tab,
    TabGroup,
    TabList,
    TabPanel,
    TabPanels,
    TransitionChild,
    TransitionRoot,
  } from '@headlessui/vue'
  import {
    Bars3Icon,
    MagnifyingGlassIcon,
    QuestionMarkCircleIcon,
    ShoppingBagIcon,
    XMarkIcon,
  } from '@heroicons/vue/24/outline'
  
export default /*@__PURE__*/_defineComponent({
  __name: 'AppHeader',
  setup(__props) {

  const mobileMenuOpen = ref(false)
  const navigation = ref({
    categories: [] as Category[], // Inicializamos vacío
    brands: [] as Brand[], // Inicializamos vacío
    shapes: [] as Shape[], // Inicializamos vacío
    pages: [
      { name: 'Tecnologías', href: '/technologies' },
      { name: 'Revisión Visual', href: '/visual-review' },
      { name: 'Nuestras Tiendas', href: '/stores' },
    ],
  });
  const loading = ref(true);
  const error = ref<string | null>(null);
  onMounted(async () => {
    try {
      const data = await getCategories();
      navigation.value.categories = data.categories; // Asignamos las categorías
      navigation.value.brands = data.brands; // Asignamos las marcas
      navigation.value.shapes = data.shapes; // Asignamos las formas
    } catch (err) {
      error.value = 'Error loading categories';
      console.error(err);
    } finally {
      loading.value = false;
    }
  });

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(TransitionRoot), {
      as: "template",
      show: mobileMenuOpen.value
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Dialog), {
          class: "relative z-40 lg:hidden",
          onClose: _cache[1] || (_cache[1] = ($event: any) => (mobileMenuOpen.value = false))
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(TransitionChild), {
              as: "template",
              enter: "transition-opacity ease-linear duration-300",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "transition-opacity ease-linear duration-300",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [
                _createElementVNode("div", { class: "fixed inset-0 bg-black/25" }, null, -1)
              ])),
              _: 1
            }),
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "transition ease-in-out duration-300 transform",
                "enter-from": "-translate-x-full",
                "enter-to": "translate-x-0",
                leave: "transition ease-in-out duration-300 transform",
                "leave-from": "translate-x-0",
                "leave-to": "-translate-x-full"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DialogPanel), { class: "relative flex w-full max-w-xs flex-col overflow-y-auto bg-white pb-12 shadow-xl" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "-m-2 inline-flex items-center justify-center rounded-md p-2 text-gray-400",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (mobileMenuOpen.value = false))
                        }, [
                          _cache[4] || (_cache[4] = _createElementVNode("span", { class: "sr-only" }, "Close menu", -1)),
                          _createVNode(_unref(XMarkIcon), {
                            class: "size-6",
                            "aria-hidden": "true"
                          })
                        ])
                      ]),
                      _createVNode(_unref(TabGroup), {
                        as: "div",
                        class: "mt-2"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_3, [
                            _createVNode(_unref(TabList), { class: "-mb-px flex space-x-8 px-4" }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navigation.value.categories, (category) => {
                                  return (_openBlock(), _createBlock(_unref(Tab), {
                                    as: "template",
                                    key: category.name
                                  }, {
                                    default: _withCtx(({ selected }) => [
                                      _createElementVNode("button", {
                                        class: _normalizeClass([selected ? 'border-indigo-600 text-indigo-600' : 'border-transparent text-gray-900', 'flex-1 whitespace-nowrap border-b-2 px-1 py-4 text-base font-medium'])
                                      }, _toDisplayString(category.name), 3)
                                    ]),
                                    _: 2
                                  }, 1024))
                                }), 128))
                              ]),
                              _: 1
                            })
                          ]),
                          _createVNode(_unref(TabPanels), { as: "template" }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navigation.value.categories, (category) => {
                                return (_openBlock(), _createBlock(_unref(TabPanel), {
                                  key: category.name,
                                  class: "space-y-12 px-4 py-6"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_4, [
                                      _createElementVNode("div", null, [
                                        _cache[5] || (_cache[5] = _createElementVNode("h1", null, [
                                          _createElementVNode("b", null, "Categorias")
                                        ], -1)),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(category.subcategories, (item) => {
                                          return (_openBlock(), _createElementBlock("p", {
                                            key: item.name,
                                            "aria-hidden": "true",
                                            class: "mt-1 text-sm font-medium text-gray-900"
                                          }, _toDisplayString(item.name), 1))
                                        }), 128))
                                      ]),
                                      _createElementVNode("div", null, [
                                        _cache[6] || (_cache[6] = _createElementVNode("h1", null, [
                                          _createElementVNode("b", null, "Formas")
                                        ], -1)),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navigation.value.shapes, (item) => {
                                          return (_openBlock(), _createElementBlock("p", {
                                            key: item.name,
                                            "aria-hidden": "true",
                                            class: "mt-1 text-sm font-medium text-gray-900"
                                          }, _toDisplayString(item.name), 1))
                                        }), 128))
                                      ]),
                                      _createElementVNode("div", _hoisted_5, [
                                        _cache[7] || (_cache[7] = _createElementVNode("h1", null, [
                                          _createElementVNode("b", null, "Marcas")
                                        ], -1)),
                                        _createElementVNode("div", _hoisted_6, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navigation.value.brands, (item) => {
                                            return (_openBlock(), _createElementBlock("p", {
                                              key: item.name,
                                              "aria-hidden": "true",
                                              class: "mt-1 text-sm font-medium text-gray-900"
                                            }, _toDisplayString(item.name), 1))
                                          }), 128))
                                        ])
                                      ])
                                    ])
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_7, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navigation.value.pages, (page) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: page.name,
                            class: "flow-root"
                          }, [
                            _createElementVNode("a", {
                              href: page.href,
                              class: "-m-2 block p-2 font-medium text-gray-900"
                            }, _toDisplayString(page.name), 9, _hoisted_8)
                          ]))
                        }), 128))
                      ]),
                      _cache[8] || (_cache[8] = _createElementVNode("div", { class: "space-y-6 border-t border-gray-200 px-4 py-6" }, [
                        _createElementVNode("div", { class: "flow-root" }, [
                          _createElementVNode("a", {
                            href: "#",
                            class: "-m-2 block p-2 font-medium text-gray-900"
                          }, "Registrate")
                        ]),
                        _createElementVNode("div", { class: "flow-root" }, [
                          _createElementVNode("a", {
                            href: "#",
                            class: "-m-2 block p-2 font-medium text-gray-900"
                          }, "Inicia sesión")
                        ])
                      ], -1))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["show"]),
    _createElementVNode("div", _hoisted_9, [
      (_ctx.$route.name === 'home')
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, _cache[9] || (_cache[9] = [
            _createElementVNode("img", {
              src: _imports_0,
              alt: "",
              class: "size-full object-cover"
            }, null, -1)
          ])))
        : _createCommentVNode("", true),
      (_ctx.$route.name === 'home')
        ? (_openBlock(), _createElementBlock("div", _hoisted_11))
        : _createCommentVNode("", true),
      _createElementVNode("header", _hoisted_12, [
        _createElementVNode("nav", _hoisted_13, [
          _cache[20] || (_cache[20] = _createElementVNode("div", { class: "bg-gray-900" }, [
            _createElementVNode("div", { class: "mx-auto flex h-10 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8" })
          ], -1)),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("a", _hoisted_18, [
                      _cache[11] || (_cache[11] = _createElementVNode("span", { class: "sr-only" }, "Oftalmolents", -1)),
                      _createVNode(_component_router_link, {
                        to: "/",
                        class: "flex items-center text-sm font-medium text-white"
                      }, {
                        default: _withCtx(() => _cache[10] || (_cache[10] = [
                          _createElementVNode("img", {
                            class: "h-12 w-auto z-20",
                            src: _imports_1,
                            alt: ""
                          }, null, -1)
                        ])),
                        _: 1
                      })
                    ])
                  ]),
                  _createVNode(SuperMenu, {
                    class: "hidden h-full lg:flex",
                    navigation: navigation.value
                  }, null, 8, ["navigation"]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "-ml-2 p-2 text-white",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (mobileMenuOpen.value = true))
                    }, [
                      _cache[12] || (_cache[12] = _createElementVNode("span", { class: "sr-only" }, "Open menu", -1)),
                      _createVNode(_unref(Bars3Icon), {
                        class: "size-6",
                        "aria-hidden": "true"
                      })
                    ]),
                    _createElementVNode("a", _hoisted_20, [
                      _cache[13] || (_cache[13] = _createElementVNode("span", { class: "sr-only" }, "Search", -1)),
                      _createVNode(_unref(MagnifyingGlassIcon), {
                        class: "size-6",
                        "aria-hidden": "true"
                      })
                    ])
                  ]),
                  _cache[19] || (_cache[19] = _createElementVNode("a", {
                    href: "#",
                    class: "lg:hidden"
                  }, [
                    _createElementVNode("span", { class: "sr-only" }, "Your Company"),
                    _createElementVNode("img", {
                      alt: "",
                      class: "h-8 w-auto",
                      src: _imports_1
                    })
                  ], -1)),
                  _createElementVNode("div", _hoisted_21, [
                    _cache[18] || (_cache[18] = _createElementVNode("a", {
                      href: "#",
                      class: "hidden text-sm font-medium text-white lg:block"
                    }, "Search", -1)),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("a", _hoisted_23, [
                        _cache[14] || (_cache[14] = _createElementVNode("span", { class: "sr-only" }, "Help", -1)),
                        _createVNode(_unref(QuestionMarkCircleIcon), {
                          class: "size-6",
                          "aria-hidden": "true"
                        })
                      ]),
                      _cache[17] || (_cache[17] = _createElementVNode("a", {
                        href: "#",
                        class: "hidden text-sm font-medium text-white lg:block"
                      }, "Help", -1)),
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("a", _hoisted_25, [
                          _createVNode(_unref(ShoppingBagIcon), {
                            class: "size-6 shrink-0 text-white",
                            "aria-hidden": "true"
                          }),
                          _cache[15] || (_cache[15] = _createElementVNode("span", { class: "ml-2 text-sm font-medium text-white" }, "0", -1)),
                          _cache[16] || (_cache[16] = _createElementVNode("span", { class: "sr-only" }, "items in cart, view bag", -1))
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      (_ctx.$route.name === 'home')
        ? (_openBlock(), _createElementBlock("div", _hoisted_26, _cache[21] || (_cache[21] = [
            _createElementVNode("h1", { class: "text-4xl font-bold tracking-tight text-white lg:text-6xl" }, " ¡Nuevas colecciones disponibles! ", -1),
            _createElementVNode("p", { class: "mt-4 text-xl text-white" }, " Descubre los últimos modelos de nuestra colección exclusiva de verano. Diseños únicos y en stock limitado. ¡No te quedes sin los tuyos! ", -1),
            _createElementVNode("a", {
              href: "#",
              class: "mt-8 inline-block rounded-md border border-transparent bg-white px-8 py-3 text-base font-medium text-gray-900 hover:bg-gray-100"
            }, " Explorar Nuevas Colecciones ", -1)
          ])))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})